import React from 'react';
import { AppRouter } from './components/AppRouter';
import './App-apple.css';

function App() {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}

export default App;